<template>
  <div>
    <Transition name="slide-fade">
      <component
        @docStates="docStates"
        @setDialog="setDialog"
        @alertUser="alertUser"
        :item="item"
        :is="activeComponent"
        :controller="dataUser"
        :rows="rows"
        :loading="loading"
        :departaments="departaments"
      />
    </Transition>
    <v-dialog v-model="dialog" scrollable max-width="400px">
      <DialogUserDetails
        @setDialog="setDialog"
        :user="item"
        @docStates="docStates"
        :departaments="departaments"
        :date="dateAndTime"
        :userGranted="userGranted"
      />
    </v-dialog>
  </div>
</template>

<script>
import ManagementTable from "@/components/management/ManagementTable.vue";
import AddUserForm from "@/components/management/AddUserForm.vue";
import EditUserForm from "@/components/management/EditUserForm.vue";
import DialogUserDetails from "@/components/management/DialogUserDetails.vue";
import UserService from "@/api/rest-administrative/user.service";
import DepartmentService from "@/api/rest-administrative/department.service";

export default {
  components: {
    ManagementTable,
    AddUserForm,
    EditUserForm,
    DialogUserDetails,
  },
  data() {
    return {
      docState: "user",
      item: {},
      dialog: false,
      activeComponent: "ManagementTable",
      dataUser: {},
      userService: UserService,
      departmentService: DepartmentService,
      rows: [],
      loading: false,
      departaments: [],
      dateAndTime: null,
      userGranted: null,
    };
  },
  methods: {
    docStates(docState, item, dialog) {
      this.dialog = dialog;
      switch (docState) {
        case "add":
          this.activeComponent = "AddUserForm";
          break;
        case "edit":
          this.activeComponent = "EditUserForm";
          this.item = item;
          break;

        default:
          this.activeComponent = "ManagementTable";
          this.initState();
          break;
      }
    },

    async setDialog(dialog, item) {
      if (dialog == true) {
        await this.searchLastChange(item);
      }
      this.item = item;
      this.dialog = dialog;
    },
    async alertUser(alert, email, tipoAlerta) {
      this.dataUser.userEmail = email;
      this.dataUser.alert = alert;
      this.dataUser.tipoAlerta = tipoAlerta;
    },

    closeAlertUser() {
      this.dataUser.userEmail = "";
      this.dataUser.alert = false;
      this.dataUser.tipoAlerta = "";
    },

    async initState() {
      await this.getUserAll();
      await this.getAllDepartments();
    },

    async getUserAll() {
      this.loading = true;
      const response = await this.userService.getAll();
      this.rows = response.data;
      this.loading = false;
    },

    async getAllDepartments() {
      const response = await this.departmentService.getAllDepartments();
      this.departaments = response.data;
      this.departaments.push({
        id: 0,
        name: "Todos",
      });
      this.departaments = this.departaments.reverse();
    },
    async searchLastChange(user) {
      const response = await this.userService.getUser(user.id);
      if (response.data.grantedUpdatedAt) {
        const userGranted = await this.userService.getUser(
          response.data.userGranted
        );
        this.userGranted = userGranted.data.name;
        const dataTime = new Date(response.data.grantedUpdatedAt);
        this.dateAndTime = `${String(dataTime.getDate()).padStart(
          2,
          "0"
        )}/${String(dataTime.getMonth() + 1).padStart(
          2,
          "0"
        )}/${dataTime.getFullYear()} as ${String(dataTime.getHours()).padStart(
          2,
          "0"
        )}:${String(dataTime.getUTCMinutes()).padStart(2, "0")}`;
        return;
      }
      this.userGranted = "";
      this.dateAndTime = "";
    },
  },

  beforeMount() {
    this.initState();
  },
};
</script>
